import React, { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getStackedItem } from '../../Services/ConfiguratorService';
import { translate } from '../../Services/translation';
import convertUnit from '../../Services/conversions';
import { currencyFormat } from '../../Services/formatting';
import { receive } from '../../Actions/Cart.action';
import { close } from '../../Actions/Configurator.action';
import { post } from '../../Services/http';
import { updateCustomizedMessage } from '../../Actions/CustomizedMessage.action';
import LoaderBlockContent from './../LoaderBlockContent';
import { validateInputs } from './validateCuttingInputs';
import { googleAnalyticsAddToCart } from '../../Services/googleAnalytics'

const PanelSubmit = ({ quantityRef, lengthRef }) => {
  const dispatch = useDispatch(),
    configurator = useSelector((state) => state.configurator),
    selectedTab = useSelector((state) => state.configurator.selectedTab),
    stackedPrices = useSelector((state) => state.configurator.stackedPrices),
    totalWeight = useSelector((state) => state.configurator.totalWeight),
    stackedItem = getStackedItem(stackedPrices, totalWeight),
    [isLoading, setIsLoading] = useState(false);

  const {
    id,
    selections,
    rules,
    baseUnitQuantity,
    quantitySelector,
    selectedUnit,
    deliveryDetails,
    orderRow,
    salesQuantity,
    disableButton,
    isStandAlone
  } = configurator;

  const isUpdateMode = orderRow ? true : false;
  const isButtonDisabled = () => {
    if (rules && rules.isCoil) {
      return disableButton != null ? disableButton : true;
    } else if (selections != null) {
      let selection = selections;
      let isConfigured = selectedTab !== 1;
      if (isConfigured) {
        if (selection.cutCode != null) {
          let selectedCutType = rules.cutTypes.filter((c) => c.code === selection.cutCode);

          if (selectedCutType.length > 0) {
            // Check conditions for button disabled based on selectedCutType and other properties
          }
        }
      }
      return false;
    } else {
      return false;
    }
  };

  const addToCart = (selectedTab) => {
    if (validateInputs(quantityRef, lengthRef)) {
      setIsLoading(true);
      const timingLabel = `adding to cart (${id})`;
      console.time(timingLabel);
      renderGoogleAnalytics();

      post('/api/configurator/save', {
        articleNumber: id,
        quantity: baseUnitQuantity,
        salesQuantity: salesQuantity,
        selectedUnit: selectedUnit || (quantitySelector && quantitySelector.selectedUnit.id),
        orderRow,
        data: selections,
        deliveryDetails: deliveryDetails,
        isConfigured: selectedTab !== 1,
      })
        .then((response) => response.json())
        .then((cart) => {
          if (isUpdateMode == false) {
            const miniCart = document.getElementsByClassName('cart__info--hidden');
            while (miniCart.length > 0) {
              miniCart[0].classList.remove('cart__info--hidden');
            }
          }
          dispatch(receive({ ...cart, addedProduct: id }));
        })
        .finally(() => {
          console.timeEnd(timingLabel);
          setIsLoading(false);
          if (!isStandAlone) {
            dispatch(close());
          }
          dispatch(updateCustomizedMessage(translate('checkout.customizedmessage.createline.update')));
        });
    }
  };

  const renderGrandTotal = () => {
    let grandTotal = 0;

    if (stackedItem && quantitySelector) {
      let pricingUnit = quantitySelector.quantityUnits.find((u) => u.unit === stackedPrices.pricingUnit);

      // let unit = convertUnit(baseUnitQuantity, quantitySelector.baseUnit, pricingUnit);
      let unit = baseUnitQuantity * convertUnit(1, quantitySelector.baseUnit, pricingUnit).toFixed(2);
      grandTotal = unit * stackedItem.price;
    }

    return currencyFormat.format(grandTotal);
  };

  const renderGoogleAnalytics = () => {
    const product = [
      {
        name: configurator.articleName,
        id: configurator.id,
        category: configurator.breadcrumbs,
        campaignProduct: configurator.isCampaignProduct,
      },
    ];
    googleAnalyticsAddToCart(product)
  };

  return (
    <Fragment>
      {isLoading && (
        <div className='be-group-inner-loading'>
          <LoaderBlockContent />
        </div>
      )}
      {!isLoading && (
        <div className={'panel-submit' + (selectedTab === 1 ? ' panel-submit--grid' : '')} >
          {selectedTab === 1 && (
            <div>
              <div className='panel-submit__total-price'>
                {renderGrandTotal()}
              </div>
              <div className='panel-submit__info'>
                {translate('cart.priceinfo')}
              </div>
            </div>
          )}
          {/*selections && selections.isConfigured == true && (
            <div>
              <div className='total-price price-text'>
                {translate('cart.priceconfigshow')}
              </div>

              <div className='shipping'>{translate('cart.priceinfo')}</div>
            </div>
          )*/}

          <div>
            <a className={'button button--orange button--wide'} onClick={() => { addToCart(selectedTab); }} >
              {translate(isUpdateMode ? 'cart.update' : 'cart.add')}
            </a>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default PanelSubmit;
